export default "__VITE_ASSET__2a8sPiwE__"